import { Box, Flex } from '@chakra-ui/react';
import { FC, PropsWithChildren, ReactNode } from 'react';

import { Txt } from '@app/components/common';

type SectionCardProps = PropsWithChildren<{
  title: string;
  subtitle?: ReactNode;
  badge?: string;
  mb?: number;
}>;

export const ReadOnlyBadge = () => (
  <Box
    as="span"
    fontSize="12px"
    color="#8a94a3"
    bg="#f0f2f5"
    border="1px solid #e2e6ec"
    px="9px"
    py="2px"
    borderRadius="20px"
    whiteSpace="nowrap"
  >
    только для чтения
  </Box>
);

export const SectionCard: FC<SectionCardProps> = ({
  title,
  subtitle,
  badge,
  mb = 5,
  children,
}) => (
  <Box
    bg="white"
    border="1px solid #e2e6ec"
    borderRadius="12px"
    boxShadow="0 1px 2px rgba(16,30,54,.05)"
    overflow="hidden"
    mb={mb}
  >
    <Box px={6} pt={5} pb={subtitle ? 3 : 4}>
      <Flex alignItems="center" gap={2.5} mb={subtitle ? 1 : 0}>
        <Txt as="h2" fontSize="18px" fontWeight={700} color="#1f2937" m={0}>
          {title}
        </Txt>
        {badge && <ReadOnlyBadge />}
      </Flex>
      {subtitle && (
        <Txt fontSize="13.5px" color="#6b7280" m={0}>
          {subtitle}
        </Txt>
      )}
    </Box>
    {children}
  </Box>
);
